module.exports = __webpack_public_path__ + "static/media/raahgiri_black.8fc70f36.png";